var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 text-center pt-5" }, [
          _c("h1", { staticClass: "text-success" }, [
            _c("span", { staticClass: "fa fa-check" }),
            _vm._v(
              "\n                    " +
                _vm._s(_vm._f("trans")("st_public.sucessful-signup-message")) +
                "\n                "
            )
          ]),
          _c("div", {}, [
            _vm._v(_vm._s(_vm._f("trans")("st_public.please_wait")))
          ]),
          _c("div", {
            staticClass: "fa fa-cog fa-spin",
            staticStyle: { "font-size": "50px" }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73e4bc00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e4bc00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/successful-signup.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-73e4bc00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/successful-signup.vue
// module chunks = 47